GP.vent.on("init_js:user:plivo", function() {
   MoshPit.add_state('jump-page');
    $(function() {
        $('#twilio-wrap input').iCheck({
            checkboxClass: 'icheckbox_minimal-blue',
            increaseArea: '20%' // optional
        });
    });
});
GP.vent.on("init_js:user:jump_sms", function() {
   MoshPit.add_state('jump-page');
   $(function() {
        $('input').iCheck({
            checkboxClass: 'icheckbox_minimal-blue',
            increaseArea: '20%' // optional
        });
    });
});
GP.vent.on("init_js:user:tutorial", function() {
    $('#btn-tutorial-top').on('click', function(){
        $('html, body').animate({ scrollTop: 0 }, 400);
    });
});
GP.vent.on("init_js:user:jump", function() {
   MoshPit.add_state('jump-page');
});
GP.vent.on("init_js:user:jump_featured", function() {
   MoshPit.add_state('jump-page');
});


// For A/B test
GP.vent.on("init_js:user:jump_activate", function() {
    self.resend_validation = function() {
        $.ajax({
            url: '/members/user/validate_email/?ajax=1&send_conf=1',
            dataType: 'html',
            success: function(data) {
                $('#resend_email_txt').show();
            }
        });
    };

    $('#jump-activate-wrap').on("click", "#resend_email", self.resend_validation);
});


